import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import HrbTranslate from '../../../../../components/language/HrbTranslate'
import Button from '../../../../../components/library/buttons/Button';
import DateTime from '../../../../../components/library/common/DateTime';
import EmdashText from '../../../../../components/library/common/EmdashText';
import VerticalNameChildren from '../../../../../components/library/layout/VerticalNameChildren';
import TaskErrorText from '../../../../../components/library/workflow-tasks/TaskErrorText';
import WorkflowTask from '../../../../../components/library/workflow-tasks/WorkflowTask';
import WorkflowTaskDescriptionWithHelp from '../../../../../components/library/workflow-tasks/WorkflowTaskDescriptionWithHelp';
import TicketActions from '../../../../../store/ticketRedux';
import { useInterviewInfo } from '../../hooks/useInterviewInfoHook';
import { TaskStatus } from '../../../services/TaskStatus';
import { WorkflowTasks } from '../../../services/WorkflowTasks';
import { useTaskStatus } from '../../hooks/useTaskStatusHook';
import { useWorkflowState } from '../../hooks/useWorkflowStateHook';
import '../Workflow.scss';
import { useTicketState } from '../../hooks/useTicketStateHook';
import DoxExplorer from '../../dox/Explorer/doxExplorer';
import DoxUploader from '../../dox/Uploader/doxUploader';
import ReturnFiledApi from '../../../../../services/api/returnFiledApi';
import { trackEvent, HeapEvents } from '../../../../../services/util/AnalyticsUtil';
import ExtraMissingFilesError from './ExtraMissingFilesError';

const FileReturnRteTask = (props) => {

    const dispatch = useDispatch();
    const ticketIsOpen = useTicketState(props.ticket);
    const stateTasks = useWorkflowState(props.ticket);    
    const [readyToFile, setReadyToFile] = useState(false);
    const [tasks, setTasks] = useState([WorkflowTasks.RETURN_FILED]);
    const [returnType, , , , ] = useInterviewInfo(props.ticket);
    const [baseStatus, completions] = useTaskStatus(props.ticket, tasks);
    const [explorerShowing, setExplorerShowing] = useState(false);
    const [hasUploadedFiles, setHasUploadedFiles] = useState(false);
    const [uploaderOpen, setUploaderOpen] = useState(false);
    const [hasUploaderError, setHasUploaderError] = useState(false);
    const [status, setStatus] = useState(TaskStatus.NOT_STARTED);
    const [isCompleting, setIsCompleting] = useState(false);
    const [hasCompletionError, setHasCompletionError] = useState(false);
    const [completionErrorType, setCompletionErrorType] = useState(null);
    const [missingFiles, setMissingFiles] = useState(null);

    useEffect(() => {
        setTasks(returnType === 'coupled' ?
            [WorkflowTasks.RETURN_FILED, WorkflowTasks.RETURN_FILED_SPOUSE] :
            [WorkflowTasks.RETURN_FILED])
    }, [returnType])

    useEffect(() => {
        let ready = stateTasks.find(t => t.identifier === WorkflowTasks.RETURN_FILED)
        if (Boolean(ready) !== readyToFile) {
            setReadyToFile(Boolean(ready))
        }
    }, [stateTasks])

    const showUploader = () => {
        setUploaderOpen(true)
    }

    const onCloseUploader = () => {
        setUploaderOpen(false);
    }

    useEffect(() => {
        if ((readyToFile && baseStatus === TaskStatus.NOT_STARTED) || baseStatus === TaskStatus.IN_PROGRESS) {
            setStatus(TaskStatus.READY_TO_FILE)
        } else {
            setStatus(baseStatus)
        }
    }, [baseStatus, readyToFile])

    useEffect(() => {
        var bStatus = baseStatus;
        if (baseStatus !== TaskStatus.COMPLETE && (stateTasks || []).find(st => st.identifier === WorkflowTasks.RETURN_FILED)) {
            bStatus = TaskStatus.IN_PROGRESS
        }
        setStatus(hasUploaderError || hasCompletionError ? TaskStatus.ERROR : bStatus);
    }, [baseStatus, hasUploaderError, stateTasks, hasCompletionError])

    const onUploadsComplete = async (filesWereUploaded) => {
        if (filesWereUploaded) {
            setHasUploadedFiles(true);
        }
        setUploaderOpen(false);
    }

    const showExplorer = () => {
        setExplorerShowing(true)
    }

    const onExplorerClose = () => {
        setExplorerShowing(false)
    }

    const completeReturnFiledTaskForFiler = async () => {
        setIsCompleting(true);
        setHasCompletionError(false);
        var response = await ReturnFiledApi.create().completeReturnFiledTask(props.ticket.id, 'primary');
        if (response && response.ok) {
            if (response.data.status === TaskStatus.COMPLETE) {
                dispatch(TicketActions.getTicket(props.ticket.id));
                trackEvent(HeapEvents.COMPLETE_RTE_FILE_RETURN, props.ticket.id);
            }
            else {
                if (response.data.missingFiles) {
                    setCompletionErrorType('missing');
                    setMissingFiles(response.data.missingFiles);
                } else {
                    setCompletionErrorType('other');                    
                }
                setHasCompletionError(true);
            }
        } else {
            setCompletionErrorType('other');
            setHasCompletionError(true);
        }

        setIsCompleting(false);
    }

    const getReturnFiledDate = () => {
        var completion, data, cs;

        cs = returnType === 'coupled' ? 
            completions.filter(c => c.status === TaskStatus.COMPLETE && c.workflowTaskId === WorkflowTasks.RETURN_FILED_SPOUSE) : 
            completions.filter(c => c.status === TaskStatus.COMPLETE && c.workflowTaskId === WorkflowTasks.RETURN_FILED);
        completion = cs.length > 0 ? cs[0] : null;

        if (completion && completion.completionData) {
            data = JSON.parse(completion.completionData);                 
            return (data || {}).CompletionDate;
        }
    }

    return (
        <WorkflowTask status={status} taskId={WorkflowTasks.FILE_RETURN_RTE}>
            <div className='columns'>
                <WorkflowTaskDescriptionWithHelp
                    helpKey='0ProSupport/VDOPro/FileReturn.htm'
                    descriptions={['FileReturnTask.RteTaskStep1']}
                    classNames='p1 medium-weight'
                />
            </div>
            <div className='columns '>
                <div className='column is-offset-1 is-10'>
                    <p className='p2 step-content'><HrbTranslate text='FileReturnTask.RteTaskStep1Desc' /></p>
                    {props.ticket &&
                    <Fragment>
                        <div className='step-center-container'>
                            <Button
                                elementId='file-return-view-manage-btn'
                                labelKey='DocUploadTask.ViewManage'
                                buttonStyles='secondary'
                                onClick={showExplorer}
                                disabled={status === TaskStatus.COMPLETE || !ticketIsOpen}
                            />
                            <Button
                                elementId='file-return-upload-btn'
                                labelKey='FileReturnTask.UploadDocs'
                                buttonStyles='secondary'
                                    onClick={showUploader}
                                    disabled={status !== TaskStatus.READY_TO_FILE && status !== TaskStatus.ERROR && status !== TaskStatus.IN_PROGRESS}
                            />
                        </div>                        
                        {hasUploaderError &&
                            <TaskErrorText errorKey='FileReturnTask.ErrorSubmit' />
                        }
                        </Fragment>
                    }
                    <div className='prep-border' />
                </div>
            </div>
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-10'>
                    <p className='p1 medium-weight'><HrbTranslate text='FileReturnTask.RteTaskStep2' /></p>
                    <p className='p2 step-content'><HrbTranslate text={'FileReturnTask.RteTaskStep2Desc'} /></p>
                    <div className='prep-border' />
                </div>
            </div>
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-10'>
                    <p className='p1 medium-weight'><HrbTranslate text='FileReturnTask.RteTaskStep3' /></p>
                    <p className='p2 step-content'><HrbTranslate text={'FileReturnTask.RteTaskStep3Desc'} /></p>
                </div>
            </div>
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-10'>                    
                    {props.ticket &&
                    <div className='step-center-container'>
                        <Button
                            elementId='file-return-done-btn'
                            labelKey='FileReturnTask.ReturnFiled'
                            buttonStyles='primary'
                                onClick={completeReturnFiledTaskForFiler}
                                disabled={status !== TaskStatus.READY_TO_FILE && status !== TaskStatus.ERROR && status !== TaskStatus.IN_PROGRESS}
                            loading={isCompleting}
                            />                                                    
                    </div>
                    }
                    {hasCompletionError && completionErrorType === 'other' &&
                        <TaskErrorText errorKey='FileReturnTask.ErrorSubmit' />
                    }
                    {hasCompletionError && completionErrorType === 'missing' &&
                        <ExtraMissingFilesError completionErrorType={completionErrorType} missingFiles={missingFiles} task='fileReturn' />
                    }
                    <div className='prep-border' />
                </div>
            </div>            
            <div className='columns'>
                <div className={classnames('column is-offset-1', 'is-10')}>
                    <VerticalNameChildren
                        textKey="FileReturnTask.CompletedOn"
                        loading={!props.ticket}>
                        <p className='p1 medium-weight'>
                            <DateTime dateAndTime includeSeconds value={getReturnFiledDate()} fallbackValue={<EmdashText />} />
                        </p>
                    </VerticalNameChildren>
                </div>
            </div>
            <div className='column is-3' />
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-15'>
                </div>
            </div>
            <DoxExplorer ticket={props.ticket} show={explorerShowing}
                onClose={onExplorerClose}
            />
            <DoxUploader ticket={props.ticket} show={uploaderOpen}
                layoutType={'desktop'} onUploadsComplete={onUploadsComplete} onClose={onCloseUploader}
            />
        </WorkflowTask>
    );
}

FileReturnRteTask.whyDidYouRender = false;

FileReturnRteTask.propTypes = {
    ticket: PropTypes.object
}

export default FileReturnRteTask